import { useMutation } from 'react-query';

import { EindomfinansAPI } from '../api';

export function useSendMailMutation() {
    return useMutation(EindomfinansAPI.sendMail);
}
